document.documentElement.classList.remove('no-js');

const q = (s, c=document) => c.querySelector(s);
const qa = (s, c=document) => [...c.querySelectorAll(s)];

function toast(message) {
  const el = q('[data-toast]');
  if (!el) return;
  el.textContent = message;
  el.classList.add('is-visible');
  window.clearTimeout(window.__mfToast);
  window.__mfToast = window.setTimeout(() => el.classList.remove('is-visible'), 2600);
}

async function getCart() {
  const response = await fetch(window.Shopify.routes.root + 'cart.js', {headers: {'Accept':'application/json'}});
  if (!response.ok) throw new Error('Cart could not be loaded');
  return response.json();
}

function money(cents) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: window.marefinoCurrency || 'EUR'
    }).format(cents / 100);
  } catch (_) {
    return (cents / 100).toFixed(2) + ' €';
  }
}

async function refreshCart(openDrawer=false) {
  const cart = await getCart();
  qa('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
  const body = q('[data-cart-body]');
  const total = q('[data-cart-total]');
  if (total) total.textContent = money(cart.total_price);
  if (body) {
    body.innerHTML = cart.items.length ? cart.items.map(item => `
      <div class="mf-drawer-item">
        <a href="${item.url}"><img src="${item.image || ''}" alt="" width="72" height="72" loading="lazy"></a>
        <div>
          <a href="${item.url}"><strong>${item.product_title}</strong></a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div>${item.variant_title}</div>` : ''}
          <div>${item.quantity} × ${money(item.final_price)}</div>
        </div>
        <button class="mf-icon-button" data-remove-line="${item.key}" aria-label="Entfernen">×</button>
      </div>`).join('') : '<p>Ihr Warenkorb ist leer.</p>';
  }
  if (openDrawer) q('[data-cart-drawer]')?.classList.add('is-open');
}

document.addEventListener('click', async (event) => {
  const menu = event.target.closest('[data-menu-toggle]');
  if (menu) {
    const nav = q('[data-main-nav]');
    nav?.classList.toggle('is-open');
    menu.setAttribute('aria-expanded', nav?.classList.contains('is-open') ? 'true' : 'false');
  }

  if (event.target.closest('[data-cart-open]')) {
    event.preventDefault();
    await refreshCart(true);
  }

  if (event.target.closest('[data-cart-close]') || (event.target.matches('[data-cart-drawer]'))) {
    q('[data-cart-drawer]')?.classList.remove('is-open');
  }

  const remove = event.target.closest('[data-remove-line]');
  if (remove) {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:remove.dataset.removeLine, quantity:0})
    });
    await refreshCart();
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = q('[type="submit"]', form);
  const label = button?.textContent;
  if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt…'; }
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:'POST',
      headers:{'Accept':'application/json'},
      body:new FormData(form)
    });
    if (!response.ok) throw new Error((await response.json()).description || 'Produkt konnte nicht hinzugefügt werden.');
    await refreshCart(true);
    toast('Zum Warenkorb hinzugefügt.');
  } catch (error) {
    toast(error.message);
  } finally {
    if (button) { button.disabled = false; button.textContent = label; }
  }
});

document.addEventListener('shopify:section:load', () => refreshCart());
refreshCart().catch(()=>{});